import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import React from "react";

export const getUserCount = createServerFn({ method: "GET" }).handler(
  async () => {
    const { getDBWithInit } = await import("~/lib/db");
    const { users } = await import("~/../drizzle/schema");
    const { count, isNotNull } = await import("drizzle-orm");

    const [result] = await (
      await getDBWithInit()
    )
      .select({ count: count() })
      .from(users)
      .where(isNotNull(users.clerkUserId));

    return result.count;
  },
);

export const Route = createFileRoute("/embed/number-of-users/")({
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData({
      queryKey: ["userCount"],
      queryFn: () => getUserCount(),
    });

    return {};
  },
  component: UserCountPage,
});

function UserCountPage() {
  const { data: userCount } = useQuery({
    queryKey: ["userCount"],
    queryFn: () => getUserCount(),
  });

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-white">
      <div className="font-heading text-[min(40vw,40vh)] tabular-nums">
        {userCount}
      </div>
    </div>
  );
}
